import React from 'react';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import { BusinessInsightsProvider } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/context/BusinessInsightsProvider';
import { InsightsDashboardName } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardName/InsightsDashboardName';
import { InsightsDashboardSection } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardSection/InsightsDashboardSection';

export function BusinessAdminInsights(): JSX.Element {
  return (
    <BusinessInsightsProvider>
      <Stack y="sm">
        <InsightsDashboardName />
      </Stack>
      <InsightsDashboardSection />
    </BusinessInsightsProvider>
  );
}
